import axios from 'axios'
import { Loading, MessageBox } from 'element-ui'
import { message } from '@/js/resetMessage.js'
import router from '@/router/index.js'
import { getSn, getToken } from '@/utils/utils'
import store from '@/store'

import _ from 'lodash'
import Vue from 'vue'
import { isAes } from '@/config'
import { decryptedData, encryptedData } from '@/js/encryption'


let loadingInstance //loading 实例
let needLoadingRequestCount = 0 //当前正在请求的数量

//显示
function showLoading() {
  let main = document.querySelector('#app')
  if (main) {
    if (needLoadingRequestCount === 0 && !loadingInstance) {
      //设置全屏
      loadingInstance = Loading.service({
        target: main,
        text: '正在执行中...',
        background: 'rgba(0,0,0,0.5)',
        fullscreen: true
      })
    }
    needLoadingRequestCount++
  }
}

//关闭loading
function closeLoading() {
  Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    needLoadingRequestCount--
    needLoadingRequestCount = Math.max(needLoadingRequestCount, 0) // 保证大于等于0
    if (needLoadingRequestCount === 0) {
      if (loadingInstance) {
        hideLoading()
      }
    }
  })
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
var hideLoading = _.debounce(() => {
  loadingInstance.close()
  loadingInstance = null
}, 300)

const service = axios.create({
  timeout: 15000
})
let requestErrorArray = []
service.interceptors.request.use(
  config => {
    let token = getToken()
    let sn = getSn()
    config.headers.from = 'WEB'
    config.headers.sn = sn
    if (token) {
      config.headers['token'] = token
    }
    if (config.method === 'get') {
      config.params = {
        t: Date.parse(new Date()) / 1000,
        ...config.params
      }
      for (let key in config.params) {
        if (config.params[key] === '' || config.params[key] == null) {
          delete config.params[key]
        }
      }
    }
    // post 请求加密参数
    if (config.method === 'post') {
      //设置请求头
      config.headers['Content-Type'] = 'application/json'
      //加密
      if (isAes) {
        let data = decryptedData(JSON.stringify(config.data))
        config.data = {
          SVavTBrYY: data
        }
      }
    }
    showLoading()
    return config
  },
  error => {
    closeLoading()
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response) {
      let responseData
      if (isAes) {
        responseData = encryptedData(response.data)
      } else {
        responseData = response.data
      }
      if (response.status === 200) {
        if (responseData.code === 0) {
          closeLoading()
          return responseData

        } else {
          //如果授权失效
          if (responseData.code == 10015 || responseData.code == 401 ) {
            MessageBox.confirm('您的授权已过期，您可以取消停留在该页上，或重新登录', '确认注销', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              store.commit('auth/CLEAR_USERINFO')
              router.push({ path: '/login' })
            })
            closeLoading()
            return null
          } else {
            closeLoading()
            return responseData
          }
        }
      } else {
        Promise.reject()
      }
    }
    closeLoading()
  },
  error => {
    let response = error.response
    if (response !== undefined) {
      // 请求401时返回登录页面
      if (error.response.status === 401) {
        requestErrorArray.push(error.response.status)
        if (requestErrorArray.length <= 1)
          MessageBox.confirm('登陆失效，请重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            router.push({ path: '/login' })
          })
        return false
      } else {
        message.error({
          message: error.message,
          // type: 'error',
          duration: 3 * 1000
        })
      }
      closeLoading()
      return Promise.reject()
    } else {
      message.error({
        message: '服务器繁忙,请稍后重试!',
        type: 'error',
        duration: 3 * 1000
      })
      closeLoading()
      return Promise.reject()
    }
  }
)

export default service

